const _temp0 = require("./photos/5893.jpg");

const _temp1 = require("./photos/6546.jpg");

const _temp2 = require("./photos/6562.jpg");

const _temp3 = require("./photos/6611.jpg");

const _temp4 = require("./photos/6904.jpg");

const _temp5 = require("./photos/6916.jpg");

const _temp6 = require("./photos/7328.jpg");

const _temp7 = require("./photos/8146.jpg");

const _temp8 = require("./photos/8541.jpg");

const _temp9 = require("./photos/9087.jpg");

const _temp10 = require("./photos/fda3de81-5ac8-4693-a4d7-a88794f085cd.jpg");

module.exports = {
  "5893":   {
    "jpg": _temp0
  },
  "6546":   {
    "jpg": _temp1
  },
  "6562":   {
    "jpg": _temp2
  },
  "6611":   {
    "jpg": _temp3
  },
  "6904":   {
    "jpg": _temp4
  },
  "6916":   {
    "jpg": _temp5
  },
  "7328":   {
    "jpg": _temp6
  },
  "8146":   {
    "jpg": _temp7
  },
  "8541":   {
    "jpg": _temp8
  },
  "9087":   {
    "jpg": _temp9
  },
  "fda3de81-5ac8-4693-a4d7-a88794f085cd":   {
    "jpg": _temp10
  }
}